import * as React from "react";

class ButtonBText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonB-text buttonBC-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 433.8 139.9"
      >
        <g>
          <path
            fill="#FCFAEE"
            d="M101.1,52.8h8.2V55h-5.5v3.1h4.7v2.2h-4.7v3.6h5.7v2.2h-8.4V52.8z"
          />
          <path
            fill="#FCFAEE"
            d="M111.5,63.4c0-2.2,1.7-3.3,5.8-3.7c0-1-0.5-1.7-1.7-1.7c-0.9,0-1.8,0.4-2.8,1l-1-1.7c1.2-0.7,2.6-1.3,4.2-1.3
		c2.6,0,3.9,1.5,3.9,4.4v5.9h-2.2l-0.2-1.1h-0.1c-0.9,0.8-1.9,1.3-3,1.3C112.7,66.4,111.5,65.1,111.5,63.4z M117.3,63.3v-2
		c-2.4,0.3-3.3,1-3.3,1.9c0,0.8,0.6,1.1,1.3,1.1C116.1,64.3,116.7,64,117.3,63.3z"
          />
          <path
            fill="#FCFAEE"
            d="M121.7,65l1.2-1.7c0.9,0.7,1.8,1.1,2.7,1.1c1,0,1.5-0.4,1.5-1.1c0-0.8-1-1.1-2.1-1.5
		c-1.3-0.5-2.8-1.3-2.8-2.9c0-1.8,1.5-3.1,3.7-3.1c1.5,0,2.6,0.6,3.4,1.2l-1.2,1.6c-0.7-0.5-1.4-0.9-2.2-0.9c-0.9,0-1.3,0.4-1.3,1
		c0,0.7,1,1,2.1,1.4c1.3,0.5,2.8,1.2,2.8,3c0,1.8-1.4,3.2-4,3.2C124.2,66.4,122.7,65.8,121.7,65z"
          />
          <path
            fill="#FCFAEE"
            d="M130.9,61.1c0-3.4,2.3-5.3,4.8-5.3s4.8,1.9,4.8,5.3c0,3.3-2.3,5.3-4.8,5.3S130.9,64.5,130.9,61.1z
		 M137.9,61.1c0-1.9-0.8-3.2-2.1-3.2s-2.1,1.2-2.1,3.2c0,1.9,0.8,3.1,2.1,3.1S137.9,63,137.9,61.1z"
          />
          <path
            fill="#FCFAEE"
            d="M142.8,56.1h2.2l0.2,1.3h0.1c0.9-0.9,1.9-1.6,3.3-1.6c2.2,0,3.1,1.5,3.1,4.1v6.3H149v-6
		c0-1.5-0.4-2.1-1.4-2.1c-0.8,0-1.4,0.4-2.1,1.1v6.9h-2.6V56.1z"
          />
          <path
            fill="#FCFAEE"
            d="M156.4,59.7c-0.6-0.6-2-1.5-3-2.2l1.3-1.5c1,0.5,2.4,1.4,3,2L156.4,59.7z M158.4,61.7
		c-0.8,1.9-1.7,3.9-2.6,5.7l-1.9-1.3c0.8-1.4,2-3.6,2.9-5.7L158.4,61.7z M157.3,55c-0.6-0.6-2-1.6-2.9-2.3l1.3-1.4
		c1,0.6,2.3,1.4,3,2L157.3,55z M166.4,61.7c1,1.3,2.5,2.6,4,3.3c-0.5,0.4-1.1,1.2-1.5,1.7c-1.3-0.8-2.7-2.1-3.7-3.6v4.7h-2.1v-4.6
		c-1.1,1.5-2.5,2.8-4.1,3.6c-0.3-0.5-1-1.3-1.4-1.7c1.6-0.7,3.2-1.9,4.2-3.3h-3.2v-1.9h4.5V58h2.1v1.8h4.6v1.9H166.4z M163.8,54
		c-0.2,2.6-0.9,4-4.6,4.7c-0.1-0.5-0.6-1.3-1-1.7c3.2-0.4,3.6-1.2,3.7-3H163.8z M160.8,55.4h-1.9v-3.7h10.9v3.6h-2.1v-1.7h-6.9V55.4
		z M168.9,56.5c0.4,0,0.9,0,1.2-0.1c0,0.5,0.1,1.3,0.2,1.8c-0.3,0.1-0.8,0.1-1.3,0.1h-1.8c-1.9,0-2.3-0.6-2.3-2.4V54h1.9v1.9
		c0,0.4,0.1,0.6,0.4,0.6H168.9z"
          />
          <path
            fill="#FCFAEE"
            d="M174,63.3v1.4h-1.9V52.3h5.3v11H174z M174,54.3v7h1.4v-7H174z M188,57.2c-0.5,2.8-1.4,5-2.7,6.7
		c1,0.8,2.1,1.5,3.4,2c-0.5,0.4-1.1,1.2-1.4,1.7c-1.3-0.6-2.4-1.3-3.4-2.2c-1,0.9-2.2,1.7-3.4,2.2c-0.3-0.5-0.9-1.4-1.3-1.7
		c1.3-0.5,2.4-1.1,3.4-2c-0.8-1-1.4-2.2-2-3.5c-0.5,2.9-1.5,5.6-3.3,7.3c-0.3-0.4-1-1.1-1.5-1.4c2.9-2.7,3.3-8.1,3.3-12.5h-1.2v-1.9
		h6.7l0.3-0.1l1.5,0.2c-0.2,1.5-0.5,3.3-0.8,4.8h0.7l0.4-0.1L188,57.2z M181.2,53.8c0,1-0.1,2-0.2,3h2.6c0.2-1,0.4-2.1,0.6-3H181.2z
		 M181.9,58.8c0.5,1.4,1.2,2.6,2,3.7c0.8-1,1.3-2.3,1.7-3.7H181.9z"
          />
          <path fill="#FCFAEE" d="M206.2,58v2.3h-16.6V58H206.2z" />
          <path
            fill="#FCFAEE"
            d="M223,52.7v14.7h-2.4v-1.4h-9.5v1.5h-2.3V52.7H223z M220.7,63.7v-8.8h-9.5v8.8H220.7z"
          />
          <path
            fill="#FCFAEE"
            d="M239.4,57c-0.1,4.9,0.1,8.5,1.2,8.5c0.3,0,0.4-1,0.4-2.5c0.4,0.5,0.9,1.1,1.4,1.4c-0.1,2.3-0.6,3.3-1.9,3.3
		c-2.7,0-3.1-3.8-3.2-9.1h-9.7v-1.4c-0.2,0.2-0.4,0.4-0.6,0.5c-0.3-0.4-1-1.3-1.5-1.7c1.7-1.2,3.2-3.1,4-5.1l2.1,0.6
		c-0.1,0.3-0.3,0.6-0.4,0.9h10.6v1.6h-11.5c-0.1,0.2-0.3,0.5-0.5,0.7h10.4v1.5h-10.5v-1.4c-0.6,0.8-1.2,1.5-1.9,2.1H239.4z
		 M230.7,64.1c-0.8,1.4-2.2,2.8-3.7,3.5c-0.3-0.5-0.9-1.2-1.3-1.5c1.3-0.5,2.7-1.5,3.4-2.6L230.7,64.1z M232.8,63.3v4.3h-2v-4.3
		h-4.4v-1.6h2.1c-0.2-0.6-0.6-1.5-1.1-2.1L229,59c0.5,0.6,1,1.5,1.2,2.1l-1.5,0.6h2.2V59h2v2.7h1.5l-1-0.4c0.4-0.6,1-1.6,1.2-2.3
		l1.9,0.6c-0.6,0.7-1.2,1.5-1.6,2.1h2.2v1.6H232.8z M234.3,63.5c1.1,0.7,2.6,1.8,3.3,2.6l-1.3,1.3c-0.7-0.8-2.2-1.9-3.3-2.7
		L234.3,63.5z"
          />
          <path
            fill="#FCFAEE"
            d="M245.3,61.8c1.4-0.5,2.2-1.2,2.3-2.2c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7-0.6-1.7-1.6c0-1,0.8-1.6,1.8-1.6
		c1.3,0,1.9,1,1.9,2.5c0,2-1.3,3.7-3.5,4.4L245.3,61.8z"
          />
          <path
            fill="#FCFAEE"
            d="M258.1,58.5c0.7,0.7,2.3,2.6,2.7,3.1l-1.2,1.8c-0.3-0.6-0.9-1.5-1.5-2.4v6.6H256v-6.4
		c-0.7,1.7-1.6,3.2-2.5,4.3c-0.2-0.6-0.7-1.5-1.1-2c1.2-1.3,2.4-3.4,3.1-5.3h-2.7v-2h3.2v-2.3c-0.9,0.1-1.7,0.3-2.6,0.4
		c-0.1-0.5-0.3-1.2-0.6-1.7c2.3-0.3,5-0.9,6.6-1.5l1.4,1.7c-0.8,0.3-1.7,0.5-2.7,0.8v2.8h2.6v2h-2.6V58.5z M268.4,52.6v14.1h-2.2
		v-1.3h-2.9v1.4h-2.1V52.6H268.4z M266.2,63.4v-8.7h-2.9v8.7H266.2z"
          />
          <path
            fill="#FCFAEE"
            d="M285.5,63.9c0.5,0.3,1.3,0.6,1.8,0.7c-0.2,2.4-0.8,3-2.6,3H282c-2.3,0-2.8-0.6-2.8-2.6v-2.9
		c-1,2.4-3.1,4.4-7.4,5.5c-0.2-0.6-0.7-1.4-1.2-1.8c3.6-0.9,5.4-2.3,6.4-4.1h-4.5v-4.2c-0.2,0.2-0.4,0.3-0.6,0.5
		c-0.3-0.5-1-1.3-1.5-1.6c2.5-1.6,4.2-3.8,5.1-5.7l2.3,0.4c-0.1,0.3-0.3,0.6-0.5,0.8h3.6l0.3-0.1l1.5,1c-0.5,0.8-1.1,1.7-1.7,2.5h5
		v6.4h-2.4C284.2,62.5,285.1,63.3,285.5,63.9L285.5,63.9z M277.5,60c0.2-0.8,0.3-1.7,0.4-2.6h-3.4V60H277.5z M276,53.9
		c-0.4,0.6-0.8,1.1-1.3,1.6h3.7c0.4-0.5,0.8-1,1.2-1.6H276z M283.6,57.3h-3.5c-0.1,0.9-0.2,1.8-0.4,2.6h3.9V57.3z M284.6,65.7
		c0.6,0,0.8-0.3,0.9-1.7l-1.3,1.2c-0.5-0.6-1.5-1.7-2.3-2.4l1.2-1h-1.7v3.2c0,0.6,0.1,0.7,0.9,0.7H284.6z"
          />
          <path
            fill="#FCFAEE"
            d="M303.5,63.9c0.5,0.3,1.3,0.6,1.8,0.7c-0.2,2.4-0.8,3-2.6,3H300c-2.3,0-2.8-0.6-2.8-2.6v-2.9
		c-1,2.4-3.1,4.4-7.4,5.5c-0.2-0.6-0.7-1.4-1.2-1.8c3.6-0.9,5.4-2.3,6.4-4.1h-4.5v-4.2c-0.2,0.2-0.4,0.3-0.6,0.5
		c-0.3-0.5-1-1.3-1.5-1.6c2.5-1.6,4.2-3.8,5.1-5.7l2.3,0.4c-0.1,0.3-0.3,0.6-0.5,0.8h3.6l0.3-0.1l1.5,1c-0.5,0.8-1.1,1.7-1.7,2.5h5
		v6.4h-2.4C302.2,62.5,303.1,63.3,303.5,63.9L303.5,63.9z M295.5,60c0.2-0.8,0.3-1.7,0.4-2.6h-3.4V60H295.5z M294,53.9
		c-0.4,0.6-0.8,1.1-1.3,1.6h3.7c0.4-0.5,0.8-1,1.2-1.6H294z M301.6,57.3h-3.5c-0.1,0.9-0.2,1.8-0.4,2.6h3.9V57.3z M302.6,65.7
		c0.6,0,0.8-0.3,0.9-1.7l-1.3,1.2c-0.5-0.6-1.5-1.7-2.3-2.4l1.2-1h-1.7v3.2c0,0.6,0.1,0.7,0.9,0.7H302.6z"
          />
          <path
            fill="#FCFAEE"
            d="M321.3,65.6c0.3,0,0.4-0.2,0.4-1.9c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.4-0.7,3.1-2,3.1h-1.2c-1.6,0-2-0.6-2-2.5
		v-3.6h-0.8c-0.3,2.8-0.9,5.1-3.9,6.4c-0.2-0.4-0.7-1.1-1.1-1.5v0.4h-3.5v0.8h-1.8v-6.2h5.3v4.8c2.2-1,2.6-2.6,2.8-4.7h-1.2v-4.9
		c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3-0.4-1.1-1.2-1.5-1.5l0.1-0.1h-5.6v-1.7h2.7c-0.2-0.7-0.5-1.6-0.9-2.3l1.8-0.6
		c0.4,0.7,0.8,1.7,1,2.3l-1.4,0.5h3.2v1c1-1,2-2.4,2.6-3.7l2,0.6c-0.6,1.4-1.5,2.8-2.5,4h6.2c-0.8-1.2-1.9-2.6-3-3.7l1.5-1
		c1.4,1.4,3.1,3.4,3.8,4.8l-1.6,1.2c-0.1-0.2-0.2-0.4-0.4-0.6v5.1h-1.1V65c0,0.5,0,0.6,0.3,0.6H321.3z M312.3,58h-5.1v-1.6h5.1V58z
		 M307.3,58.8h5.1v1.6h-5.1V58.8z M310.8,63h-1.7v2h1.7V63z M316.2,59.6h3.2v-2h-3.2V59.6z"
          />
          <path
            fill="#FCFAEE"
            d="M105.9,85.4l1.7,1.4c-1.6,0.9-4.1,1.9-6,2.5c-0.3-0.5-0.9-1.2-1.4-1.6c1.9-0.5,4.2-1.5,5.5-2.3h-5.3v-2h3
		v-7.2H101v-2h2.5v-1.7h2.1v1.7h5.7v-1.7h2.2v1.7h2.6v2h-2.6v7.2h3.1v2H105.9z M105.6,76.3v1.1h5.7v-1.1H105.6z M105.6,80.4h5.7
		v-1.2h-5.7V80.4z M105.6,83.5h5.7v-1.3h-5.7V83.5z M110.9,85.6c2,0.7,4.4,1.7,5.7,2.3l-2.1,1.4c-1.2-0.7-3.2-1.7-5.2-2.4
		L110.9,85.6z"
          />
          <path
            fill="#FCFAEE"
            d="M134.8,77.6v1.5h-3.3l-0.1,1.4H121l0.2-1.4h-2.8v-1.5h3l0.2-1.4h10.2l-0.1,1.4H134.8z M130,86.9
		c1.6,0.4,3.2,0.9,4.2,1.2l-1.5,1.3c-1.3-0.5-3.4-1.2-5.5-1.7l0.7-0.8h-3.3l1.1,0.8c-1.5,0.8-4,1.5-6.1,1.8
		c-0.3-0.4-0.8-1.1-1.1-1.5c1.6-0.2,3.4-0.6,4.7-1.1h-2.6V81h11.7v5.8H130z M120.8,77.1h-1.9V74h6.6c-0.1-0.4-0.3-0.8-0.5-1.1
		l1.9-0.5c0.3,0.5,0.6,1.1,0.8,1.6h6.6v3.1h-2v-1.5h-11.4V77.1z M122.8,82.6h7.5v-0.5h-7.5V82.6z M122.8,84.2h7.5v-0.6h-7.5V84.2z
		 M122.8,85.8h7.5v-0.6h-7.5V85.8z M123.1,79.4h2.4l0.1-0.6h-2.4L123.1,79.4z M123.3,77.3l-0.1,0.5h2.4l0.1-0.5H123.3z M129.5,79.4
		l0.1-0.6h-2.3l-0.1,0.6H129.5z M129.7,77.3h-2.3l0,0.5h2.3L129.7,77.3z"
          />
          <path
            fill="#FCFAEE"
            d="M141.9,73.2c-0.5,1.3-1.1,2.6-1.8,3.8v12.2h-2.1v-9.1c-0.4,0.5-0.8,0.9-1.1,1.3c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L141.9,73.2z M149.7,87.2c1.1,0,1.3-0.5,1.4-2.5c0.5,0.3,1.3,0.7,1.9,0.8c-0.3,2.7-0.9,3.6-3.1,3.6h-4.1
		c-2.5,0-3.2-0.6-3.2-3.2v-5l-1.4,0.5l-0.8-1.9l2.2-0.8v-4.2h2v3.4l1.8-0.7v-4.7h1.9v3.9l2.4-0.9l0.2-0.1l1.6,0.5l-0.1,0.3
		c-0.1,2.6-0.3,6-0.7,8.2l-1.8-0.5c0.2-1.5,0.3-3.9,0.4-6.1l-2,0.8v6.4h-1.9v-5.6l-1.8,0.7V86c0,1.1,0.2,1.2,1.4,1.2H149.7z"
          />
          <path
            fill="#FCFAEE"
            d="M160,77.3c-0.4,0.7-0.9,1.5-1.5,2.2v9.9h-2.1v-7.5c-0.5,0.5-1.1,1-1.6,1.5c-0.2-0.5-0.7-1.7-1-2.2
		c1.5-1.1,3.3-2.9,4.3-4.6L160,77.3z M159.7,73.4c-1.2,1.7-3,3.4-4.6,4.5c-0.2-0.5-0.8-1.4-1.1-1.8c1.4-0.9,2.9-2.3,3.6-3.5
		L159.7,73.4z M170.4,83.2c-0.8,0.7-1.9,1.4-2.7,1.9c0.9,1,2,1.8,3.3,2.3c-0.5,0.4-1.1,1.3-1.4,1.9c-3.1-1.4-4.7-4.2-5.7-7.8h-1.1
		v5.1l2.5-0.6c0,0.6,0,1.5,0.1,2c-3.5,0.9-4.2,1.2-4.6,1.4c-0.1-0.5-0.6-1.3-0.9-1.7c0.4-0.2,0.8-0.7,0.8-1.6V73.2h8.7v8.3h-3.6
		c0.3,0.8,0.6,1.5,0.9,2.2c0.8-0.6,1.8-1.4,2.4-2L170.4,83.2z M162.7,75.1v1.4h4.5v-1.4H162.7z M162.7,79.6h4.5v-1.5h-4.5V79.6z"
          />
          <path
            fill="#FCFAEE"
            d="M188.6,81.7v1.7h-16v-1.7h7v-0.8h-5.3v-1.6h5.3v-0.6c-1.8,0.1-3.6,0.1-5.2,0.1c0-0.3-0.1-0.7-0.2-1.1h-1.1V74
		h6.7c-0.2-0.4-0.4-0.8-0.6-1.1l2.1-0.6c0.3,0.5,0.7,1.2,1,1.7h6v3.7h-1.3l0.2,0.2c-1.6,0.3-3.5,0.5-5.6,0.7v0.7h5.5v1.6h-5.5v0.8
		H188.6z M175,84.1h11.2v5.2h-2.2v-0.5h-7v0.5H175V84.1z M175,77.3c1.5,0,3-0.1,4.5-0.1v-1.1h2v1c1.7-0.1,3.2-0.3,4.3-0.5l0.1,0.1
		v-0.8H175V77.3z M177.1,85.8v1.4h7v-1.4H177.1z"
          />
          <path
            fill="#FCFAEE"
            d="M190,80.7c0.5-1.2,0.8-3.2,0.9-4.7l1.6,0.2c-0.1,1.5-0.4,3.7-0.8,5.1L190,80.7z M206.4,75.7v13.5h-2.2v-0.7
		h-5.1v0.8H197V78.9l-1.6,0.7c-0.1-0.7-0.5-1.8-0.9-2.8v12.5h-2.1V72.5h2.1V76l1.2-0.5c0.5,1.1,1.1,2.5,1.3,3.4v-3.2h3.1
		c0.2-1,0.5-2.2,0.5-3.1l2.5,0.3c-0.3,1-0.6,2-0.9,2.9H206.4z M199.1,77.7V81h5.1v-3.3H199.1z M204.2,86.4V83h-5.1v3.4H204.2z"
          />
          <path
            fill="#FCFAEE"
            d="M215.5,80.6c-0.8,0-1.3-0.1-1.7-0.2c-1.3,0.5-2.6,0.9-3.9,1.2c-0.2-0.4-0.8-1.1-1.1-1.5c1.4-0.2,2.8-0.6,4-1
		c0-0.2,0-0.3,0-0.5v-2.2h1.8v2.1c2-0.8,3.7-1.8,4.8-3.1l1.6,0.7c-1.1,1.2-2.5,2.2-4.1,3h1.9c0.7,0,0.8-0.1,0.9-0.9
		c0.4,0.2,1.1,0.4,1.6,0.5c-0.2,1.5-0.8,1.9-2.3,1.9H215.5z M209,78.6c0.6-0.4,1.3-1.2,1.7-1.9h-1.9v-3h6.7
		c-0.1-0.3-0.3-0.6-0.4-0.9l2-0.4c0.2,0.4,0.5,0.9,0.7,1.3h6.4v3h-2v-1.4h-5.9c0.5,0.3,1.1,0.6,1.4,0.9l-1.2,1.1
		c-0.5-0.5-1.5-1.1-2.4-1.5l0.6-0.5h-4.1v1.3l0.1-0.1l1.5,0.8c-0.5,0.8-1.1,1.7-1.9,2.4L209,78.6z M221.6,85.8
		c1.1,0.8,2.3,1.9,2.9,2.5l-1.7,1.1c-0.3-0.3-0.6-0.6-0.9-1c-4.6,0.2-9.5,0.4-12.7,0.5l-0.2-1.8c1.7,0,4-0.1,6.4-0.2v-1.2h-5v-4.2h5
		v-0.8h2.1v0.8h5.3v4.2H221.6z M215.4,84.2v-1.1h-2.9v1.1H215.4z M217.5,83.2v1.1h3.1v-1.1H217.5z M220,86.8
		c-0.2-0.2-0.5-0.4-0.7-0.6l0.8-0.5h-2.6v1.1L220,86.8z M221.4,76.6c1,0.7,2.3,1.7,2.9,2.5l-1.6,0.9c-0.5-0.8-1.7-1.9-2.8-2.6
		L221.4,76.6z"
          />
          <path
            fill="#FCFAEE"
            d="M238.8,85.6h3.8v1.6h-3.8v2.1h-2v-2.1h-3.5c0,0.3,0.1,0.5,0.1,0.8l-1.6,0.4c0-0.3-0.1-0.8-0.2-1.2
		c-1.9,0.4-3.7,0.8-5.2,1.2l-0.4-1.9c0.8-0.1,1.7-0.3,2.7-0.5v-3.3h-0.7v0.6h-1.5v-7.6h2.2v-3.1h1.7v3.1h2.2v0.8
		c1.4-1,2.7-2.5,3.4-4.1L238,73c-0.1,0.3-0.3,0.6-0.5,1h2.6l0.3-0.1l1.2,0.6c-0.5,1.4-1.3,2.6-2.3,3.5c1.1,0.6,2.4,1.1,3.9,1.3
		c-0.4,0.4-1,1.2-1.2,1.7c-1.6-0.4-3-1-4.2-1.8c-1.3,0.9-2.9,1.5-4.5,2c-0.1-0.3-0.4-0.7-0.6-1v2.5h-2.3v2.9l0.9-0.2
		c-0.1-0.5-0.3-1.1-0.4-1.6l1.5-0.4c0.3,1.1,0.6,2.5,0.8,3.6v-1.4h3.5v-0.8h-2.7v-1.5h2.7v-0.8h-3v-1.5h3V80h2v1.1h3.1v1.5h-3.1v0.8
		h2.8v1.5h-2.8V85.6z M228.1,81h0.9v-3.5h-0.9V81z M231.2,77.5h-0.9V81h0.9V77.5z M232.7,79.5c1.3-0.3,2.5-0.8,3.6-1.5
		c-0.4-0.4-0.7-0.8-1.1-1.2c-0.4,0.4-0.9,0.8-1.3,1.2c-0.3-0.3-0.8-0.7-1.2-1V79.5z M236.5,75.6c0.4,0.5,0.8,1,1.3,1.4
		c0.5-0.4,0.9-0.9,1.2-1.4H236.5z"
          />
          <path
            fill="#FCFAEE"
            d="M248.1,78c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9C245.1,79.3,246.5,78,248.1,78
		z M248.1,82.5c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C246.4,81.8,247.2,82.5,248.1,82.5z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonBText;



// WEBPACK FOOTER //
// ./src/storyA/components/ButtonBText.tsx